import { Card, CardContent } from '@material-ui/core';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { INSURANCE_PRODUCTS } from '../../../constants';
import LifeDetails from '../../../pages/components/life-details';
import { setLineOfBusiness } from '../../../pages/redux/actions';
import { LifeFormProps } from './types';

const Life = ({
  onNextTab,
  onPrevTab,
  currentIndex,
  setLineOfBusiness,
  goToLastTab,
  add,
}: LifeFormProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setLineOfBusiness(INSURANCE_PRODUCTS[6]);
  }, [setLineOfBusiness]);

  return (
    <>
      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <Card elevation={0} className='applicant-home-form'>
                <CardContent>
                  <LifeDetails
                    onNextTab={onNextTab}
                    onPrevTab={onPrevTab}
                    currentIndex={currentIndex}
                    goToLastTab={goToLastTab}
                    add={add}
                  />
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapDispatchToProps = (dispatch: any): AppComponents.LifeFormDispatch =>
  bindActionCreators({ setLineOfBusiness }, dispatch);

export default connect(() => {}, mapDispatchToProps)(Life);
